import React from 'react';

import { useTransactionContext } from 'context';
import PaymentPlan from './PaymentPlan';
import styles from './PaymentSelector.module.css';

const PaymentSelector = ({ tabIndex = 0 }) => {

  const {
    paymentPlans,
    selectedPaymentPlan
  } = useTransactionContext();
  return (
    <div className={styles.root} role="radiogroup" id="plans" aria-label="plans" value={selectedPaymentPlan?.id}>
      {paymentPlans?.map((plan, i) => {
        const data = { ...plan };
        delete data.id;
        delete data.type;

        return <PaymentPlan key={plan.id} id={plan.id} type={plan.type} data={data} index={tabIndex + i} />;
      })}
    </div>
  );
};

export default PaymentSelector;
